import { forwardRef } from 'react';


const VerticalNavTabItem = forwardRef(({
  role,
  spanIconclass,
  spanTextclass,
  title,
  tabMenuText,
  icon,
  active,
  isDataChanged,
  ...props
}, ref) => {





  const onTabClickHandler = () => {
    isDataChanged(title);
  };

  


  return (
    <>
      <a
        ref={ref}
        title={tabMenuText}
        className={`nav-link tab-style ${active ? 'active' : ''} `}
        id={`v-tabs-${title}-tab`}
        data-bs-toggle="tab"
        href={`#v-tabs-${title}`}
        role="tab"
        aria-controls={`v-tabs-${title}`}
        aria-selected={active}
        onMouseDown={onTabClickHandler}
        //{...props}
      >
        <span className={`material-icons me-1 ${spanIconclass}`} title={title}>
          {icon}
        </span>
        <span className={spanTextclass}> {tabMenuText}</span>
      </a>

    </>
  );
});



export default VerticalNavTabItem;
